<template>
  <!-- 移动到 -->
  <div
    aria-labelledby="myModalLabel"
    class="modal fade"
    id="move2"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span aria-hidden="true">×</span>
          </button>
          <h4 class="modal-title" id="myModalLabel">移动到</h4>
        </div>
        <div class="modal-body">
          <div class="file-move">
            <div class id="treeview-move2"></div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" data-dismiss="modal" type="button">
            取消
          </button>
          <button
            class="btn btn-primary"
            type="button"
            @click="moveToFolder"
            :disabled="isProcessing"
          >
            {{ isProcessing ? "正在移动..." : "确定" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TableMoveSelected",
  data() {
    return {
      isProcessing: false,
    };
  },
  computed: {
    selectedFolder() {
      return this.$store.state.drive.selectedFolder;
    },
    selectedDatas() {
      return this.$store.state.drive.selectedDatas;
    },
    groupNumber() {
      return this.$store.state.drive.groupNumber;
    },
  },
  methods: {
    moveToFolder() {
      if (this.isProcessing) {
        return false;
      }
      this.isProcessing = true;
      if (!this.selectedFolder) {
        this.$message({
          type: "warning",
          message: "请选择目标文件夹",
        });
        this.isProcessing = false;
        return false;
      }
      let files_list = this.selectedDatas.map(function (item) {
        return {
          number: item.number,
          type: item.type,
        };
      });
      this.$store.commit("operationFileOrFolderData", {
        group_number: this.groupNumber,
        action: "move",
        number: this.selectedFolder.number,
        disk_type: this.selectedFolder.disk_type,
        files_list: files_list,
      });
      this.$store
        .dispatch("moveToFolder")
        .then((res) => {
          if (res.status_code === 200) {
            this.isProcessing = false;
            $("#move2").modal("hide");
            this.$message({
              type: "success",
              message: res.message,
            });
            this.$store.dispatch("getInfo");
          } else {
            this.isProcessing = false;
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.isProcessing = false;
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },
};
</script>

<style>
</style>